import "css/semantic/semantic.less";
import "css/main.less";

import { store } from "app";
import * as config from "config/index";
import * as lib from "lib/index";

window.app = {
  get store() {
    return store;
  },
  get state() {
    return store.getState();
  },
  dispatch(...args) {
    return store.dispatch(...args);
  },
  config,
  lib,
};

if (module.hot) {
  module.hot.accept("config/index", () => {
    app.config = config;
  });
  module.hot.accept("lib/index", () => {
    app.lib = lib;
  });
}



// WEBPACK FOOTER //
// ./src/main.js